const ar: Record<string, string> = {
  // Navbar
  "nav.search": "بحث",
  "nav.dubai": "دبي",
  "nav.saudi": "السعودية",
  "nav.qatar": "قطر",
  "nav.kuwait": "الكويت",
  "nav.oman": "عُمان",
  "nav.bahrain": "البحرين",
  "nav.turkey": "تركيا",
  "nav.pakistan": "باكستان",
  "nav.israel": "إسرائيل",
  "nav.donateInfants": "تبرع للأطفال",
  "nav.influencers": "المؤثرون",
  "nav.howItWorks": "كيف يعمل",
  "nav.registerFactory": "سجّل مصنعك",
  "nav.rfq": "طلب عرض سعر",
  "nav.dashboard": "لوحة التحكم",
  "nav.requestQuote": "طلب عرض سعر",
  "nav.browseByCountry": "تصفح حسب الدولة",
  "nav.more": "المزيد",
  "nav.searchFactories": "البحث عن المصانع",
  "nav.influencerProgram": "برنامج المؤثرين",
  "nav.supplierDashboard": "لوحة تحكم المورد",
  "nav.factoryBuyer": "مصنع ومشترٍ",
  "nav.home": "الرئيسية",
  "nav.register": "تسجيل",
  "nav.countries": "الدول",
  "nav.selectCountry": "اختر دولة لاستكشاف المصانع",

  // Hero
  "hero.badge": "+٥ ملايين مصنع موثّق · الشرق الأوسط والعالم",
  "hero.headline1": "مشترون عالميون كثيرون",
  "hero.headline2": "يطلبون عشرات الحاويات",
  "hero.headline3": "سنوياً",
  "hero.subheadline": "من مصانع SuperMiddleEast الموثّقة",
  "hero.tagline": "نجوم عالميون يساعدون المصانع الموثّقة على البيع للعالم —",
  "hero.tagline2": "المشترون بالجملة، الدروبشيبرز، والمؤثرون في منصة واحدة.",
  "hero.searchPlaceholder": "ابحث عن منتجات أو موردين...",
  "hero.allCategories": "جميع الفئات",
  "hero.electronics": "إلكترونيات",
  "hero.textiles": "منسوجات",
  "hero.machinery": "آلات",
  "hero.food": "أغذية ومشروبات",
  "hero.furniture": "أثاث",
  "hero.beauty": "جمال وعناية",
  "hero.allCountries": "جميع الدول",
  "hero.search": "بحث",
  "hero.dropshippingProducts": "منتجات الدروبشيبينج",
  "hero.verifiedSuppliers": "موردون موثّقون",
  "hero.registerSupplier": "سجّل كمورد",
  "hero.influencerCatalog": "كتالوج المؤثرين",

  // Trust Banner
  "trust.verifiedFactories": "مصنع موثّق",
  "trust.countriesServed": "دولة تخدمها",
  "trust.dropshippingReady": "جاهز للدروبشيبينج",
  "trust.influencerPartners": "شريك مؤثر",

  // Categories
  "categories.label": "تصفح حسب الفئة",
  "categories.title": "استكشف فئات المنتجات",
  "categories.subtitle": "من الإلكترونيات إلى المنسوجات — اعثر على موردين موثّقين في كل صناعة",
  "categories.viewSuppliers": "عرض الموردين",
  "categories.products": "منتج",

  // Country Factories Section
  "factories.subtitle": "طلبات عينات، طلبات جملة، ودروبشيبينج — كل ذلك من منصة واحدة. كل مصنع موثّق من فريقنا.",
  "factories.registerFactory": "سجّل مصنعك",
  "factories.viewAll": "عرض جميع المصانع",
  "factories.verifiedFactories": "مصانع موثّقة",
  "factories.dropshippingReady": "جاهز للدروبشيبينج",
  "factories.productsListed": "منتج مدرج",
  "factories.warehouseCountries": "دول المستودعات",
  "factories.allFactories": "جميع المصانع",
  "factories.verifiedOnly": "✓ الموثّقة فقط",
  "factories.dropshippingOnly": "🚚 الدروبشيبينج فقط",
  "factories.searchPlaceholder": "ابحث عن مصانع أو فئات...",
  "factories.howToOrder": "كيفية الطلب",
  "factories.step1": "تصفح المصانع والمنتجات",
  "factories.step2": "اختر طلب عينة أو جملة",
  "factories.step3": "حدد الكمية وأكّد",
  "factories.step4": "المصنع يشحن إليك",
  "factories.noResults": "لا توجد مصانع تطابق بحثك.",
  "factories.ctaTitle": "هل أنت صاحب مصنع؟",
  "factories.ctaSubtitle": "أدرج منتجاتك، حدد أسعارك، وابدأ في استقبال طلبات العينات والجملة من المشترين العالميين اليوم.",
  "factories.howItWorks": "كيف يعمل",

  // Dubai
  "dubai.subtitle": "دبي، الإمارات العربية المتحدة",
  "dubai.title": "مصانع دبي الموثّقة",
  "dubai.ctaTitle": "هل أنت صاحب مصنع في دبي؟",

  // Saudi
  "saudi.subtitle": "المملكة العربية السعودية",
  "saudi.title": "مصانع السعودية الموثّقة",
  "saudi.ctaTitle": "هل أنت صاحب مصنع في السعودية؟",

  // Qatar
  "qatar.subtitle": "دولة قطر",
  "qatar.title": "مصانع قطر الموثّقة",

  // Kuwait
  "kuwait.subtitle": "دولة الكويت",
  "kuwait.title": "مصانع الكويت الموثّقة",

  // Oman
  "oman.subtitle": "سلطنة عُمان",
  "oman.title": "مصانع عُمان الموثّقة",

  // Bahrain
  "bahrain.subtitle": "مملكة البحرين",
  "bahrain.title": "مصانع البحرين الموثّقة",

  // Turkey
  "turkey.subtitle": "جمهورية تركيا",
  "turkey.title": "مصانع تركيا الموثّقة",

  // Pakistan
  "pakistan.subtitle": "جمهورية باكستان الإسلامية",
  "pakistan.title": "مصانع باكستان الموثّقة",

  // Dropshipping Section
  "dropship.label": "برنامج الدروبشيبينج",
  "dropship.title1": "ابدأ الدروبشيبينج",
  "dropship.title2": "بدون مخزون",
  "dropship.desc": "تعاون مع ٥ ملايين مصنع موثّق في الشرق الأوسط وآسيا. بع عالمياً دون الاحتفاظ بمخزون — نحن نتولى الشحن، وأنت تتولى المبيعات.",
  "dropship.benefit1": "شحن مباشر من المصانع الموثّقة",
  "dropship.benefit2": "خيارات مستودعات محلية في أكثر من ٥٠ دولة",
  "dropship.benefit3": "مجموعات منتجات منتقاة من المؤثرين",
  "dropship.benefit4": "صفر مخاطر مخزون للدروبشيبرز",
  "dropship.browseBtn": "تصفح منتجات الدروبشيبينج",
  "dropship.howBtn": "كيف يعمل",
  "dropship.stat1": "منتج دروبشيبينج",
  "dropship.stat2": "مستودع محلي",
  "dropship.stat3": "متوسط المعالجة",
  "dropship.stat4": "نجاح التسليم",

  // Footer
  "footer.tagline": "ربط ٥ ملايين مصنع موثّق بالمشترين العالميين. جاهز للدروبشيبينج، مدعوم بالمؤثرين.",
  "footer.stayUpdated": "ابقَ على اطلاع",
  "footer.emailPlaceholder": "بريدك الإلكتروني",
  "footer.join": "انضم",
  "footer.thankYou": "شكراً لاشتراكك!",
  "footer.marketplace": "السوق",
  "footer.findSuppliers": "ابحث عن موردين",
  "footer.browseProducts": "تصفح المنتجات",
  "footer.dropshippingHub": "مركز الدروبشيبينج",
  "footer.verifiedFactories": "المصانع الموثّقة",
  "footer.countryPages": "صفحات الدول",
  "footer.forSuppliers": "للموردين",
  "footer.registerSupplier": "سجّل كمورد",
  "footer.verificationProcess": "عملية التحقق",
  "footer.pricingPlans": "خطط الأسعار",
  "footer.influencerProgram": "برنامج المؤثرين",
  "footer.sellerResources": "موارد البائعين",
  "footer.contactUs": "اتصل بنا",
  "footer.headquarters": "المقر الرئيسي",
  "footer.address": "مركز دبي التجاري العالمي\nشارع الشيخ زايد، دبي، الإمارات",
  "footer.rights": "© ٢٠٢٦ SuperMiddleEast · جميع الحقوق محفوظة",
  "footer.privacy": "سياسة الخصوصية",
  "footer.terms": "شروط الخدمة",
};

export default ar;
